import { QLE_ACTION_TYPES } from '@constants/actionTypes/qleVerificationActionTypes';
import { IQLEVerificationDocumentResponse } from '@modules/qle/types/qleTypes';

export const setQLEVerificationsData = (data:IQLEVerificationDocumentResponse) => ({
    type: QLE_ACTION_TYPES.SET_QLE_VERIFICATIONS_DATA,
    payload: data,
});

export const overrideDocument = (data:IQLEVerificationDocumentResponse) => ({
    type: QLE_ACTION_TYPES.OVERRIDE_DOCUMENT,
    payload: data,
});
